<div class="modal-container">
  <h2 class="modal-title" *ngIf="title.length">
    {{ title }}
  </h2>
  <div class="modal-content">
    <p [innerHTML]="description" class="modal-text"> </p>
    <p class="modal-info"> </p>
  </div>

  <div class="modal-actions">
    <button class="btn btn-secondary" (click)="onCancel()"> NO </button>
    <button class="btn btn-primary" (click)="onConfirmSave()"> YES </button>
  </div>
</div>
